import {ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, SimpleChanges, ViewChild, ViewChildren} from '@angular/core';
import {FormGroup} from "@angular/forms";
import {
  FormFieldBase, FormFieldType
} from "../../../../components/dynamic-form-field/components/dynamic-form-light/models/form-field-base";
import {
  ProtocolFindFascicoloRequest,
  ProtocolFindFascicoloResponse
} from "../../../models/dto/protocol-fascicolo";
import {ProtocolService} from "../../../services/protocol.service";
import {
  FormFieldControlService
} from "../../../../components/dynamic-form-field/components/dynamic-form-light/services/dynamic-form-field-control.service";
import {ProtocolError, ProtocolMetadata} from "../../../models/protocol";
import {ProtocolStore} from "../../../stores/protocol-store";
import { ModalNotifyService } from 'src/app/core/services/modal-notify.service';
import { DialogRef } from 'src/app/core/components/dialog/dialog-ref';
import { catchError, Observable, switchMap, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { FascicoloFull } from 'src/app/common/models/fascicolo/fascicolo-full';
import { DocumentoAllegato } from 'src/app/common/models/documento-allegato';
import { TipoDocumento } from 'src/app/common/models/tipologiche/tipo-documento';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { FileManagerService } from 'src/app/core/components/upload-tool/services/file-manager.service';
import { FileUploadResponse } from 'src/app/common/models/dto/file-upload-response';
import { ServicePathsSettings } from 'src/app/core/configuration/service-paths-settings';
import { FileData } from 'src/app/common/models/file-data';
import { RequestProtocol } from '../../../models/dto/request-fascicolo-protocol';
import { MetadatoDocumento } from 'src/app/common/form/documento/document-uploaded/campi';
import { OperationsService } from 'src/app/core/services/operations.service';
import { TipoTipologica } from 'src/app/common/models/tipologiche/tipo-tipologica';
import { UploadDocumentUtilityService } from 'src/app/common/form/documento/document-uploaded/upload-document-utility.service';

declare var closeModal: any;
declare var openModal: any;
export namespace ProtocolSearchFormFields {
  export const ANNO_PROTOCOL: FormFieldBase = {
    controlType: FormFieldType[FormFieldType.TEXT],
    key: "protocol-search-data-anno",
    label: "Anno protocollo",
    required: true,
    pattern: "\^[12][0-9]{3}$",
    errors:{pattern:'Formato anno non valido'},
    disabled: false
    // placeholder: "2023",
    // chips: false
  }
  export const NUMERO_PROTOCOL: FormFieldBase = {
    controlType: FormFieldType[FormFieldType.TEXT],
    key: "protocol-search-data-numero",
    label: "Numero protocollo",
    required: true,
    pattern: "\\d{1,255}",
    errors:{pattern:'Formato del numero non valido'},
    disabled: false
    // placeholder: "215426",
    // chips: false
  }
}

@Component({
  selector: 'app-protocol-fascicolo-search',
  templateUrl: './protocol-fascicolo-search.component.html',
  styleUrls: ['./protocol-fascicolo-search.component.css']
})
export class ProtocolFascicoloSearchComponent implements OnInit {

  @Output() onSearch = new EventEmitter<ProtocolFindFascicoloRequest>();
  @Output() onImport = new EventEmitter<ProtocolFindFascicoloRequest>();
  @ViewChild('target') target: ElementRef;
  @Input() isDocumentazione: boolean = false;
  @Input() fascicolo: FascicoloFull;
  @Input() idPratica: string;
  form: FormGroup = ProtocolStore.getSearchForm();
  protected formFields: FormFieldBase[];
  activeIndex: number = undefined;
  openAccordion = true;
  result = null;
  isDocumentInserted: boolean = false;
  fileUploadList: DocumentoAllegato[] = [];
  tipoDocumentoOption: TipoDocumento[];
  loading: boolean;
  fileToUpload: any;
  private valid_files: any[] = [];
  requestProtocol: RequestProtocol = {} as RequestProtocol;
  fileUploaded: boolean;
  fileUploadedName: string;
  tipoProduttore?: 'INTERNO' | 'ESTERNO';
  @ViewChildren('typeDocSelect') typeDocSelect: QueryList<ElementRef>;
  constructor(
    private service: ProtocolService,
    private dialogRef: DialogRef,
    private formFieldControlService: FormFieldControlService,
    private notify: ModalNotifyService,
    private helpers: HelpersService,
    private route: ActivatedRoute,
    private fileManager: FileManagerService,
    private http: HttpClient,
    private cdr: ChangeDetectorRef,
    protected operationService: OperationsService,
    private uploadUtilityService: UploadDocumentUtilityService
  ) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['fascicolo'] && changes['fascicolo'].currentValue) {
    }
  }

  public ngOnInit() {
    this.initForm();
  }

  initForm() {
    // this.results.forEach(x => x["active"] = true);
    this.formFields = [];
    //this.uploadUtilityService.resetTipoProduttoreInitialized();
    this.formFields.push(ProtocolSearchFormFields.ANNO_PROTOCOL);
    this.formFields.push(ProtocolSearchFormFields.NUMERO_PROTOCOL);

    if(!this.form) {
      this.form = this.formFieldControlService.toFormGroup(this.formFields, this.form);
      ProtocolStore.setSearchForm(this.form);
      ProtocolStore.cleanSearchCache();
    }
    this.helpers.getTipiDocumenti().subscribe(response => {
      this.tipoDocumentoOption = response && response.length > 0
        ? response.sort((a, b) => a.label.toLowerCase() < b.label.toLowerCase() ? -1 : 1)
        : [];
    });
      // this.uploadUtilityService.tipoProduttoreChanges.subscribe(value => {

      // if (!value) return;
      // this.fileUploadList.forEach(f => {
      //   f.metadatoDocumento = {
      //     ...f.metadatoDocumento,
      //     tipoUfficioProduttore: this.mapToTipoTipologica(value.value)
      //   };
      // });
      // });
    }

  protected onFormFieldEvent(event) { }

  onReset() {
    this.form.reset();
    this.result = null;
    this.fileUploadList = [];
    //this.uploadUtilityService.resetTipoProduttoreInitialized();
    this.requestProtocol = {} as RequestProtocol;
  }

  protected onSubmit(event) {
    if (this.form.valid) {
      let req = {
        protocolYear: this.form.controls[ProtocolSearchFormFields.ANNO_PROTOCOL.key].value,
        protocolNumber: this.form.controls[ProtocolSearchFormFields.NUMERO_PROTOCOL.key].value,
      }
      // this.result = {
      //   "metadata": {
      //       "protocolYear": "2024",
      //       "creatAt": "08/05/2024 16:49",
      //       "idDoc": "17323668",
      //       "dossierNumber": null,
      //       "protocolNumber": "82",
      //       "subject": "Oggetto da TlfFOR",
      //       "senderReceiver": "20-0-0-0-18 - Servizio Autonomo Avvocatura Comunale - Postazione piattaforma Teleforum",
      //   },
      //   "documenti": [
      //     {
      //       "id": "c6da6d39-cef5-4b02-a178-b90a1ca72d7e",
      //       "nomeFile": "240718123619-Atto.pdf.p7m",
      //       "tipoDocumento": {
      //           "id": "66f22ec5-db0e-11ee-b4e0-0242ac1f0007",
      //           "descrizione": "ATTO TELEMATICO",
      //           "label": "ATTO TELEMATICO",
      //           "rimosso": false
      //       },
      //       "contentType": "application/x-pkcs7-mime",
      //       "flagAllegatoPrincipale": false,
      //     },
      //     {
      //       "id": "c6da6d39-cef5-4b02-a178-b90a1ca72d7e",
      //       "nomeFile": "240718123619-Atto.pdf.p7m",
      //       "tipoDocumento": {
      //           "id": "66f22ec5-db0e-11ee-b4e0-0242ac1f0007",
      //           "descrizione": "ATTO TELEMATICO",
      //           "label": "ATTO TELEMATICO",
      //           "rimosso": false
      //       },
      //       "contentType": "application/x-pkcs7-mime",
      //       "flagAllegatoPrincipale": true,
      //     }
      //   ]
      // };
      // this.result.documenti.sort(x => x.flagAllegatoPrincipale ? -1 : 1)
      this.service.getPreview(req).pipe(
        catchError(this.handleError)
      ).subscribe(it => {
        if (!it.metadata) {
          this.dialogRef.close();
          this.onError("Protocollo non trovato");
          return;
        }
        this.result = it;
        this.result.documenti.sort(x => x.flagAllegatoPrincipale ? -1 : 1)
        this.target.nativeElement.scrollIntoView();
      });
    }
  }

  private handleError(error: HttpErrorResponse) {
    if(error) {
      if(document.getElementById("modalmodDatiGenerali")) {
        openModal("modalmodDatiGenerali")
      }
      // this.dialogRef?.close();
    }
    return throwError(() => error.error);
  }


  protected onError(message: string) {
    if(document.getElementById("modalmodDatiGenerali")) {
      openModal("modalmodDatiGenerali")
    }
    this.notify.customMessage(message);
  }

  protected isFormValid() {
    return this.form.valid;
  }

  openDetail(event, index) {
    event.preventDefault();
    // this.results[index].active = !this.results[index].active;
    this.openAccordion = !this.openAccordion;
  }

  importData(event) {
    event.stopPropagation();
    event.preventDefault();
    let req = {
      protocolYear: this.form.controls[ProtocolSearchFormFields.ANNO_PROTOCOL.key].value,
      protocolNumber: this.form.controls[ProtocolSearchFormFields.NUMERO_PROTOCOL.key].value,
      documentProtocol: this.requestProtocol.documentProtocol,
      idFascicolo:'',
      idPratica:''
    }
    if (this.isDocumentazione || this.fascicolo?.id) {
      req.idFascicolo = this.fascicolo.id;
    }
    this.result.metadata.protocolYear = req.protocolYear;
    this.result.metadata.protocolDocuments = req.documentProtocol;
    req.idPratica = this.idPratica;
    req.documentProtocol = this.requestProtocol.documentProtocol.map(dp => {
    const file = this.fileUploadList.find(f => f.refDocumentale === dp.documentRef);
      return {
        ...dp,
        metadatoDocumento: file?.metadatoDocumento
      };
    });
    this.service.importProtocol(req).subscribe(res => {
      this.onImport.emit(this.result);
      this.fileUploadList = [];
      this.requestProtocol = {} as RequestProtocol;
    });
  }

  changePrimary(documentRef: string) {
    this.requestProtocol.documentProtocol.forEach(m => {
      m.primary = (m.documentRef === documentRef);
    });

    this.typeDocSelect.forEach(el => {
      const currentType= el.nativeElement.value;
      const isPrimary = this.requestProtocol.documentProtocol.some(m => m.type === currentType && m.primary);

    if (!isPrimary && currentType !== this.requestProtocol.documentProtocol.find(m => m.documentRef === documentRef)?.type) {
      el.nativeElement.value = null;
    }
  });

    this.cdr.detectChanges();
  }

  getPrimary(documentRef: string): boolean{
    return this.requestProtocol.documentProtocol.some(elem => elem.documentRef === documentRef && elem.primary);
  }

  onTypeDocChange(event, item) {
    let index = this.requestProtocol.documentProtocol.findIndex(el => el.documentRef === item.refDocumentale);
    if(index > -1) {
      this.requestProtocol.documentProtocol[index].type = event.target.value === "null" ? null : event.target.value;
    }
  }

  deleteFile(refDocumentale: string, index: number) {
    let itemDeleted = this.requestProtocol.documentProtocol.splice(this.requestProtocol.documentProtocol.findIndex(elem => elem.documentRef === refDocumentale),1);
    if(itemDeleted[0].primary && this.requestProtocol.documentProtocol.length > 0){
      this.requestProtocol.documentProtocol[0].primary = true;
    }
    this.fileUploadList.splice(index,1);
  }

  onSearchChange(fileInput: any) {
    let files = fileInput;
    this.loading = true;
    // if (files.length > 0) {
    //   let files = fileInput.target.files;
    // }
    for (var i = 0; i < files.length; i++) {
      this.fileToUpload = files[i];
      this.valid_files.push(files[i]);
      this.uploadFile(
        this.fileToUpload,
        Number(i) == files.length - 1
      ).subscribe((res) => {
        if (res && res.fileData) {
          this.setFileDataRequest(res.fileData);
          this.fileUploaded = true;
          this.fileUploadedName = res.fileData.nomeFile;
          //this.onReturn.emit(res.fileData)
        }
      });
    }
    this.loading = false;
  }

  uploadFile(file: File, isLastOne?): Observable<FileUploadResponse> {
    return this.fileManager
      .getPayloadFile(file)
      .pipe(switchMap((res) => this.getObsFileUploadResponse(res)));
  }

  private getObsFileUploadResponse(payload: {
    fileData: {};
  }): Observable<FileUploadResponse> {
    return this.http.post<FileUploadResponse>(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_UPLOAD_DOCUMENTO,
      payload,
      { withCredentials: true }
    );
  }

  setFileDataRequest(fileData: FileData) {
    if(this.requestProtocol.documentProtocol == null){
      this.requestProtocol.documentProtocol = [];
    }
    let primaryPresent: boolean = this.requestProtocol.documentProtocol.some(elem => elem.primary);
    this.requestProtocol.documentProtocol.push({
      documentRef: fileData.refDocumentale,
      primary: !primaryPresent
    });
    let fileDaAllegare = new DocumentoAllegato();
    fileDaAllegare.refDocumentale = fileData.refDocumentale;
    fileDaAllegare.nomeFile = fileData.nomeFile;
    fileDaAllegare.contentType = fileData.contentType;
    fileDaAllegare.contentSize = fileData.contentSize;
    fileDaAllegare.signedData = fileData.signedData ?? null;
    fileDaAllegare.algoritmoImprontaDocumento = fileData.algoritmoImprontaDocumento;
    fileDaAllegare.improntaDocumento = fileData.improntaDocumento;
    fileDaAllegare.metadatoDocumento = {
      modalitaFormazioneDocumento: { id: 'A', descrizione: '', label: '', rimosso: false },
      tipoUfficioProduttore: { id: 'ESTERNO', descrizione: '', label: '', rimosso: false }
    };
    this.fileUploadList.push(fileDaAllegare);
  }

  checkValidity(): boolean {
    // Controlla se esiste almeno un file con firma non valida E produttore interno
     const hasInvalidInternalDoc = this.fileUploadList.some(file =>
      file?.signedData?.statoFirma === 'NON_VALIDA' &&
      file?.metadatoDocumento?.tipoUfficioProduttore?.id === 'INTERNO'
    );

    if (hasInvalidInternalDoc) {
      return false;
    }

    if (hasInvalidInternalDoc) return false;

    // Controlla che tutti i file abbiano tipoUfficioProduttore valorizzato
    const allFilesHaveTipoUfficio = this.fileUploadList.every(file =>
      file.metadatoDocumento?.tipoUfficioProduttore
    );
    if (!allFilesHaveTipoUfficio) return false;

    return (
      !!this.requestProtocol.documentProtocol &&
      this.requestProtocol.documentProtocol.length > 0 &&
      this.requestProtocol.documentProtocol.findIndex(itm => !itm.type) === -1
    );
  }
  
   onExtractArchive(event: {response: any, refDocumentale:string}) {
    const documenti: FileData[] = event.response.filesData;
    for (const element of documenti) {
      this.setFileDataRequest(element);
    }
    // rimuove lo zip
    let index = this.fileUploadList.findIndex(x => x.refDocumentale === event.refDocumentale);
    this.fileUploadList.splice(index, 1);
    // rimuove lo ZIP/EML dalla requestProtocol
    const indexProtocol = this.requestProtocol.documentProtocol.findIndex(
    d => d.documentRef === event.refDocumentale
    );
    if (indexProtocol !== -1) {
      this.requestProtocol.documentProtocol.splice(indexProtocol, 1);
    }
  }

  onDocReturn(event: any) {
      if (!event || !event.refDocumentale) return;
       this.tipoProduttore = event.tipoUfficioProduttore;
      const newDoc = {
        documentRef: event.refDocumentale,
        primary: event.primary,
        type: event.type
      };
  
      const existingIndex = this.requestProtocol.documentProtocol
        .findIndex(d => d.documentRef === newDoc.documentRef);
  
        if (existingIndex !== -1) {
          // aggiorna solo i valori passati
          this.requestProtocol.documentProtocol[existingIndex] = {
            ...this.requestProtocol.documentProtocol[existingIndex],
            ...newDoc
          };
        } else {
          this.requestProtocol.documentProtocol.push(newDoc);
        }
        const idx = this.fileUploadList.findIndex(f => f.refDocumentale === event.refDocumentale);
        if (idx > -1) {
          const doc = this.fileUploadList[idx];
          const nuovoMetadato: MetadatoDocumento = {
            modalitaFormazioneDocumento: this.mapToTipoTipologica(event.modalitaFormazioneDocumento),
            motivoAssenzaFirma: this.mapToTipoTipologica(event.motivoAssenzaFirma),
            documentoUnico: event.documentoUnico,
            tipoUfficioProduttore: this.mapToTipoTipologica(
              event.tipoUfficioProduttore ?? 'ESTERNO'
            ),
            ufficioProduttore: event.ufficioProduttore,
            numDocumentiScansione: event.numDocumentiScansione,
            documentiScansionati: event.documentiScansionati
          };
  
        doc.metadatoDocumento = nuovoMetadato;
        this.fileUploadList = [...this.fileUploadList];
      }
    }

    mapToTipoTipologica = (key?: string): TipoTipologica | undefined => {
      if (!key) return undefined;
      return { id: key, descrizione: '', label: '', rimosso: false };
    };

}
